import { LoadingScreen } from '../../components/LoadingScreen/LoadingScreen.tsx';
import { useGetAccount } from '../../hooks/api/schema-hooks/useGetAccount.ts';
import { AccountModule } from '../../modules/account/AccountModule.tsx';
import { editAccountFormSubmit } from '../../redux/features/accountSlice.ts';
import { useAppDispatch } from '../../redux/hooks.ts';
import { apiAccountToToolkitAccount } from '../../utils/apiAccountToToolkitAccount.ts';
import { useToolkitControllerGlobal } from '../hooks/useToolkitControllerGlobal.ts';
import { useUpdateToolkitAccount } from '../hooks/useUpdateToolkitAccount.ts';

export const AccountRouteElement = () => {
  const dispatch = useAppDispatch();
  const { subscription } = useToolkitControllerGlobal();
  const getAccount = useGetAccount({});
  const { mutateAsync: updateAccount, isLoading: isUpdatingAccount } = useUpdateToolkitAccount({
    async onSuccess(result) {
      await getAccount.refetch();
      dispatch(editAccountFormSubmit(result));
    },
  });

  if (getAccount.isLoading) {
    return <LoadingScreen what="Profile" />;
  }

  if (getAccount.isError) {
    throw Error(`Failed to load profile: ${getAccount.error}`);
  }

  return (
    <AccountModule
      account={apiAccountToToolkitAccount(getAccount.data)}
      subscription={subscription}
      updateAccount={updateAccount}
      isUpdatingAccount={isUpdatingAccount}
    />
  );
};
